var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 733.26 355.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1-2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "527.33 0 301.19 225.83 187.84 225.83 286.76 125.81 204.97 125.81 78.14 252.57 78.14 284.31 306.97 284.31 356.24 234.68 470.75 234.68 360.08 351.64 0 351.64 0 216.41 157.44 58.68 354.23 58.4 412.82 0 527.33 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "733.26 355.1 624.9 355.1 398.77 129.27 513.28 129.27 733.26 349.52 733.26 355.1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaLogoBlack);
export default __webpack_public_path__ + "static/media/ca_logo_black.a20cd07079edece18f42e3c90598586a.svg";
export { ForwardRef as ReactComponent };